export function ChatSearchResults({ showSearchResults, filteredConversations, onOpenConversation }) {
  if (!showSearchResults) {
    return null;
  }

  return (
    <div
      data-testid="conversation-search-results"
      className="max-h-48 space-y-2 overflow-y-auto rounded-sm border border-zinc-800 bg-zinc-900/50 p-2"
    >
      {filteredConversations.length === 0 ? (
        <p className="py-4 text-center text-sm text-muted-foreground">Aucune conversation trouvée</p>
      ) : (
        filteredConversations.map((conversation) => (
          <button
            key={conversation.id}
            type="button"
            data-testid={`conversation-search-result-${conversation.id}`}
            onClick={() => onOpenConversation(conversation.id)}
            className="w-full rounded-sm border border-zinc-800 bg-zinc-900/50 p-3 text-left text-sm transition-colors hover:border-white"
          >
            {conversation.title}
          </button>
        ))
      )}
    </div>
  );
}
